import { render, staticRenderFns } from "./shoppingCartOrdersCard.vue?vue&type=template&id=0d01f63b"
import script from "./shoppingCartOrdersCard.vue?vue&type=script&lang=js"
export * from "./shoppingCartOrdersCard.vue?vue&type=script&lang=js"
import style0 from "./shoppingCartOrdersCard.vue?vue&type=style&index=0&id=0d01f63b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports